"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmwasmQueriesImpl = exports.CosmwasmQueries = void 0;
const cw20_contract_info_1 = require("./cw20-contract-info");
const cw20_balance_1 = require("./cw20-balance");
exports.CosmwasmQueries = {
    use() {
        return (queriesSetBase, kvStore, chainId, chainGetter) => {
            return {
                cosmwasm: new CosmwasmQueriesImpl(queriesSetBase, kvStore, chainId, chainGetter),
            };
        };
    },
};
class CosmwasmQueriesImpl {
    constructor(base, kvStore, chainId, chainGetter) {
        base.queryBalances.addBalanceRegistry(new cw20_balance_1.ObservableQueryCw20BalanceRegistry(kvStore));
        this.querycw20ContractInfo = new cw20_contract_info_1.ObservableQueryCw20ContractInfo(kvStore, chainId, chainGetter);
    }
}
exports.CosmwasmQueriesImpl = CosmwasmQueriesImpl;
//# sourceMappingURL=queries.js.map